/*
MIT LICENSE
Copyright (c) 2020-present Alibaba Cloud Design
Copied from 'antd/components/steps/index.tsx'.
Copyright (c) 2015-present Ant UED, https://xtech.antfin.com/

Permission is hereby granted, free of charge, to any person obtaining
a copy of this software and associated documentation files (the
"Software"), to deal in the Software without restriction, including
without limitation the rights to use, copy, modify, merge, publish,
distribute, sublicense, and/or sell copies of the Software, and to
permit persons to whom the Software is furnished to do so, subject to
the following conditions:

The above copyright notice and this permission notice shall be
included in all copies or substantial portions of the Software.

THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND,
EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND
NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE
LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION
OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION
WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE. */
import React from 'react';
import classNames from 'classnames';
import RcSteps from 'rc-steps';
import useBreakpoint from '../grid/hooks/useBreakpoint';
import { ConfigContext, withConfigProvider } from '../config-provider';
import AnimationContext from '../config-provider/AnimationContext';
import { StepProps } from 'antd';
import { Progress } from '../progress';
import { Icon } from '../icon';
import warning from 'antd/es/_util/warning';
const ConfiguredStep = withConfigProvider(RcSteps.Step);
export const Steps = (props) => {
    const { size, className, direction } = props;
    const { percent, responsive, line, disabled, children, type, ...otherProps } = props;
    if (process.env.NODE_ENV !== 'production')
        warning(props.roundBar !== false, 'step', `'roundBar' is deprecated now`);
    const { xs } = useBreakpoint();
    const { getPrefixCls, direction: rtlDirection } = React.useContext(ConfigContext);
    const animation = React.useContext(AnimationContext);
    const getDirection = React.useCallback(() => (responsive && xs ? 'vertical' : direction), [xs, direction]);
    const prefixCls = getPrefixCls('steps', props.prefixCls);
    const iconPrefix = getPrefixCls('', props.iconPrefix);
    const stepsClassName = classNames({
        [`${prefixCls}-disabled`]: disabled === true,
        [`${prefixCls}-line`]: line === true,
        // [`${prefixCls}-roundBar`]: roundBar === true,
        [`${prefixCls}-rtl`]: rtlDirection === 'rtl',
        [`${prefixCls}-with-progress`]: percent !== undefined,
        [`${prefixCls}-breathing`]: animation?.breathing
    }, className);
    const icons = {
        finish: React.createElement(Icon, { className: `${prefixCls}-finish-icon`, type: 'checkmark--outline' }),
        error: React.createElement(Icon, { className: `${prefixCls}-error-icon`, type: 'misuse--outline' })
    };
    const stepIconRender = ({ node, status, index }) => {
        if (status === 'process' && percent !== undefined) {
            // currently it's hard-coded, since we can't easily read the actually width of icon
            const progressWidth = size === 'small' ? 20 : 28;
            const iconWithProgress = (React.createElement("div", { className: `${prefixCls}-progress-icon` },
                React.createElement(Progress, { type: 'circle', percent: percent, width: progressWidth, strokeWidth: 4, format: () => null }),
                node));
            return iconWithProgress;
        }
        // 	return <div className={`${prefixCls}-line-index`}>{index > 9 ? index + 1 : `0${index + 1}`}</div>;
        // }
        // if (roundBar) {
        // 	if (status === 'finish') {
        // 		return (
        // 			<div className={`${prefixCls}-round-bar-icon`}>
        // 				<Icon type='Checkmark-filled' size='small' />
        // 			</div>
        // 		);
        // 	}
        // 	if (status === 'process' || status === 'wait' || status === 'error') {
        // 		return <div className={`${prefixCls}-round-bar-icon`}></div>;
        // 	}
        // }
        return node;
    };
    // Extend 'disabled' to children if the prop is available.
    let computedChildren = children;
    if (disabled === true) {
        computedChildren = React.Children.map(children, (child) => {
            if (React.isValidElement(child)) {
                const newProps = {};
                if (disabled) {
                    newProps['disabled'] = true;
                }
                return React.cloneElement(child, newProps);
            }
            else {
                return child;
            }
        });
    }
    return (React.createElement(RcSteps, { icons: icons, type: line ? 'navigation' : 'default', ...otherProps, direction: getDirection(), stepIcon: stepIconRender, prefixCls: prefixCls, iconPrefix: iconPrefix, className: stepsClassName }, computedChildren));
};
Steps.Step = ConfiguredStep;
Steps.defaultProps = {
    current: 0
};
// export default withConfigProvider(Steps);
export default Steps;
